import { render, staticRenderFns } from "./oneGoal.vue?vue&type=template&id=72bc4c89&scoped=true"
import script from "./oneGoal.vue?vue&type=script&lang=js"
export * from "./oneGoal.vue?vue&type=script&lang=js"
import style0 from "./oneGoal.vue?vue&type=style&index=0&id=72bc4c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc4c89",
  null
  
)

export default component.exports